function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
var IntroSectionComponent = function IntroSectionComponent(_ref) {
  var settings = _ref.settings;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    backgroundImage = _useState2[0],
    setBackgroundImage = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    headlinesHtml = _useState4[0],
    setHeadlinesHtml = _useState4[1];
  useEffect(function () {
    settings.preElementItems.map(function (item) {
      if (item.type === 'image') {
        setBackgroundImage(item.image.src);
      }
      if (item.type === 'text') {
        setHeadlinesHtml(item.html.html);
      }
    });
  }, [settings]);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundImage: "url(".concat(backgroundImage, ")")
    },
    className: "brain-hearing-intro__container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "brain-hearing-intro__container__headlines headlines",
    dangerouslySetInnerHTML: {
      __html: headlinesHtml
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "brain-hearing-intro__container__elements"
  }, settings.elements.map(function (item) {
    return /*#__PURE__*/React.createElement(ElementWithImage, {
      item: item.items
    });
  })));
};
var ElementWithImage = function ElementWithImage(_ref2) {
  var item = _ref2.item;
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    elementHtml = _useState6[0],
    setElementHtml = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    image = _useState8[0],
    setImage = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    link = _useState0[0],
    setLink = _useState0[1];
  useEffect(function () {
    item.map(function (element) {
      if (element.type === 'image') {
        setImage(element.image.src);
      } else if (element.type === 'text') {
        setElementHtml(element.html.html);
        var $html = new DOMParser().parseFromString(element.html.html, 'text/html');
        setLink($html.querySelector('a').getAttribute('href'));
      }
    });
  }, [item]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    role: "button",
    "data-href": link,
    "data-scroll": link,
    onClick: function onClick(e) {
      return document.querySelector(link).nextElementSibling.scrollIntoView(true);
    },
    className: "brain-hearing-intro__container__elements__element"
  }, /*#__PURE__*/React.createElement("div", {
    className: "brain-hearing-intro__container__elements__element__image"
  }, /*#__PURE__*/React.createElement("img", {
    src: image
  })), /*#__PURE__*/React.createElement("div", {
    className: "brain-hearing-intro__container__elements__element__desc",
    dangerouslySetInnerHTML: {
      __html: elementHtml
    }
  })));
};
export default IntroSectionComponent;